// This is how the data needs to look:
//
// treeData: {
//   name: 'My Tree',
//     children: [
//     { name: 'hello' },
//     { name: 'wat' },
//     {
//       name: 'child folder',
//       children: [
//         {
//           name: 'child folder',
//           children: [
//             { name: 'hello' },
//             { name: 'wat' }
//           ]
//         },
//         { name: 'hello' },
//         { name: 'wat' },
//         {
//           name: 'child folder',
//           children: [
//             { name: 'hello' },
//             { name: 'wat' }
//           ]
//         }
//       ]
//     }
//   ]
// }
import TreeItem from 'src/components/widgets/TreeItem.vue';
import Vue from 'vue';
export default Vue.extend({
    components: { TreeItem },
    props: {
        item: { type: Object, default: () => null },
        delimiter: { type: String, default: '/' },
        showFiles: { type: Boolean, default: true },
        showFolders: { type: Boolean, default: true },
        allowSelectFile: { type: Boolean, default: true },
        allowSelectFolder: { type: Boolean, default: true },
        itemClassLookup: { type: Function, default: (item) => '' },
        allowSelectMany: { type: Boolean, default: true },
        selectedKeys: { type: Object, default: () => { } },
        isLoading: { type: Boolean, default: false },
        rootFolderOpen: { type: Boolean, default: false },
        indent: { type: Number, default: 30 }
    },
    data: function () {
        return {
            logger: this.$logger.getLogger('Tree')
        };
    },
    methods: {
        selectionChanged(item, oldval, newval) {
            this.logger.debug('Tree.selectionChanged: ' + JSON.stringify(item) + ' ' + oldval + ' ' + newval);
            this.logger.trace(this.selectedKeys);
            if (newval === true && !this.allowSelectMany) {
                // Can't select multiple items, so we'll have to unselect
                // any existing selected ones.
                const existingItems = Object.keys(this.selectedKeys); // Convert set->array
                this.logger.trace(`existingItems: ${existingItems}`);
                existingItems.forEach((key) => {
                    this.logger.trace(`Sending deselect message for ${key}`);
                    this.$emit('deselectItemKey', key);
                });
            }
            let msg = newval === true ? 'selectItemKey' : 'deselectItemKey';
            this.logger.trace(`sending ${msg} event for ${item.key}`);
            this.$emit(msg, item.key);
        },
        onchange(item) {
            this.logger.trace('Tree.onchange: ' + JSON.stringify(item));
            this.$emit('change', item);
        },
        makeFolder: function (item) {
            Vue.set(item, 'children', []);
            this.addItem(item);
        },
        addItem: function (item) {
            item.children.push({
                name: 'new stuff'
            });
        }
    }
});
